if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper?.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      const variantChangeEvent = new CustomEvent('variant:change', {
        detail: { sku: this.currentVariant?.sku },
        bubbles: false
      });

      window.dispatchEvent(variantChangeEvent);


      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
        } else if (fieldset.querySelectorAll('input').length) {
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    // updateMasterId() {
    //   this.currentVariant = this.getVariantData().find((variant) => {
    //     return !variant.options.map((option, index) => {
    //       return this.options[index] === option;
    //     }).includes(false);
    //   });
    // }

    updateMasterId() {
      // Step 1: Get the variant data
      const variants = this.getVariantData();

      // Step 2: Find the variant that matches the current options
      const matchingVariant = variants.find((variant) => {
        // Step 3: Check if every option in the variant matches the corresponding option in this.options
        const allOptionsMatch = variant.options.every((option, index) => {
          return this.options[index] === option; // Check if options match
        });

        return allOptionsMatch; // Return true if all options match, otherwise false
      });

      if (matchingVariant) {
        // Step 4.a: Update the current variant with the matching variant
        this.currentVariant = matchingVariant;
      } else {
        // Step 4.b: If no variant matches, takes the first that matches main option
        this.currentVariant = variants.find(variant => {
          return variant.option1 === this.options[0]
        });

        setTimeout(() => {
          const firstOption2 = this.fieldsets[1].querySelector('input:not(.is-disabled)')
          firstOption2.click();
        }, 300)
      }
    }



    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
      }
    }
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);
      if (flkty && this.hideVariants) {
        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {

      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm, i) => {

        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available && pickUpAvailability.fetchAvailability) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;

        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.dataset.content = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.dataset.content = window.theme.variantStrings.preOrder;
          } else {
            submitButtonText.dataset.content = window.theme.variantStrings.addToCart;
          }
        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.dataset.content = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();

      if (variant_data && this.currentVariant) {

        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {

              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;

      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;

        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          // yolo!
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      window.addEventListener('variant:change', this.handleHideImages);
      this.addEventListener('change', this.setupProductGallery);
    }

    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.quickView = this.closest('#Product-Drawer-Content');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.progress_bar = this.product_container.querySelector('.flickity-progress--bar'),

        this.setOptions();
      // Start Slider
      this.init();
    }

    /**
     * Only display images of the selected variant
     */
    handleHideImages = (evt) => {

      const sku = evt.detail.sku
      if (!sku) return

      const slides = Array.from(this.querySelectorAll('.product-images__slide'));

      const slidesToShow = slides.filter(slide => {
        slide.classList.toggle('is-active', slide.dataset.mediaName?.includes(sku))

        return slide.dataset.mediaName?.includes(sku)
      })

      this.reInit()

    }

    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
      this.prev_button = this.querySelector('.flickity-prev');
      this.next_button = this.querySelector('.flickity-next');
      this.images = this.querySelectorAll('img');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        cellAlign: this.quickView ? 'left' : 'right',
        adaptiveHeight: !this.quickView,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active',
        on: {
          ready: () => {
            this.images.forEach((img) => {
              img.addEventListener('lazyloaded', () => {
                this.flkty.resize();
              });
            });
          },
          dragStart: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none");
          },
          dragEnd: () => {
            this.flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all");
          }
        }
      };
      if (this.quickView) {
        this.options.wrapAround = false;
      }
      if (this.progress_bar) {
        this.options.on.scroll = (progress) => {
          progress = Math.max(0, Math.min(1, progress));
          this.progress_bar.style.width = progress * 100 + '%';
        };
      }
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {
      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media');

        if (this.thumbnails) {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
            active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

          this.thumbnails.forEach((item, i) => {
            item.classList.remove('is-initial-selected');
          });
          active_thumb.classList.add('is-initial-selected');

          requestAnimationFrame(() => {
            if (active_thumb.offsetParent === null) {
              return;
            }
            const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
              windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
            active_thumb.parentElement.scrollTo({
              left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
              top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
              behavior: 'smooth'
            });
          });
        }


        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });

      if (this.thumbnails && !this.thumbnail_container.dataset.init) {
        setTimeout(() => {
          let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
          active_thumbs.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
              this.thumbnailClick(thumbnail, index);
            });
          });
          this.thumbnail_container.addEventListener('click', (e) => {
            let count = Math.min(Math.max(this.thumbnail_container.querySelectorAll('.is-active').length, 1), 4);
            this.thumbnail_container.style.setProperty('--thumbnail-width', (count * 63) + 19 + 'px');
            if (!this.thumbnail_container.classList.contains('extended')) {
              this.thumbnail_container.classList.add('extended');
            } else {
              if (e.target.nodeName == 'BUTTON') {
                this.thumbnail_container.classList.remove('extended');
              }
              e.preventDefault();
            }
            if (!this.thumbnail_container.classList.contains('extended')) {
              let active_thumb = this.thumbnail_container.querySelector('.is-initial-selected');
              setTimeout(() => {
                active_thumb.parentElement.scrollTo({
                  left: Math.max(active_thumb.offsetLeft, 0),
                  top: 0,
                  behavior: 'smooth'
                });
              }, 300);
            }
          });
          this.thumbnail_container.dataset.init = true;
        });
      }
    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {

      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }


    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }

      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });

      this.handleErrorMessage();


      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };


      let formData = new FormData(this.form);

      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }

          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
          if (document.querySelector('.product-add-to-cart-sticky-modal')) {
            document.querySelector('.product-add-to-cart-sticky-modal').removeAttribute('open');
          }
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
        if (section.id == 'Cart-Drawer') {
          elementToReplace.removeProductEvent();
          elementToReplace.notesToggle();
          elementToReplace.termsCheckbox();
          elementToReplace.updateFreeShipping();
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupObservers();
      this.drawer = document.getElementById(this.dataset.target);
      this.addEventListener('click', this.onClick.bind(this));
    }
    onClick() {
      this.drawer.show();
    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === footer) {
              if (entry.intersectionRatio > 0) {
                _this.classList.remove('sticky--visible');
              } else if (entry.intersectionRatio == 0 && _this.formPassed) {
                _this.classList.add('sticky--visible');
              }
            }
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();

              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio === 1) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer');
      _this.formPassed = false;
      observer.observe(form);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

function isMobile() {
  return window.matchMedia("(max-width: 1023px)").matches;
}

function option3EventDispatcher() {
  const option3Event = new CustomEvent("variant-option3-shown");
  const productPersonalizer = document.querySelectorAll('.product-personalizer');
  const personalizationContent = document.getElementById('personalization-content');
  if (productPersonalizer && personalizationContent) {
    personalizationContent.classList.remove('hidden');
    productPersonalizer.forEach((element) => {
      if (!personalizationContent.contains(element)) {
        personalizationContent.appendChild(element);
      }
    });
  }

  document.dispatchEvent(option3Event);
}

document.addEventListener("DOMContentLoaded", () => {
  const productVariantsGrid = document.querySelector('.product-variants-grid');
  const tabsContainer = document.querySelector('[data-product-variants-tabs]');

  if (tabsContainer && productVariantsGrid) {
    const accordionOption1 = productVariantsGrid.querySelector('[data-accordion-id="option1"]');
    const accordionOption2 = productVariantsGrid.querySelector('[data-accordion-id="option2"]');
    const accordionPersonalization = productVariantsGrid.querySelector('[data-accordion-id="personalization"]');

    const tabOption1 = document.getElementById('tab_option1');
    const tabOption2 = document.getElementById('tab_option2');
    const tabPersonalization = document.getElementById('tab_personalization');

    if (!isMobile() && accordionOption1 && tabOption1) {
      const option1Content = accordionOption1.querySelector('.w-full.font-futuraPT');
      if (option1Content) {
        tabOption1.innerHTML = option1Content.innerHTML;
        accordionOption1.remove();
      }
    }

    if (!isMobile() && accordionOption2 && tabOption2) {
      const option2Content = accordionOption2.querySelector('.w-full.font-futuraPT');
      if (option2Content) {
        tabOption2.innerHTML = option2Content.innerHTML;
        accordionOption2.remove();
      }
    }

    if (!isMobile() && accordionPersonalization && tabPersonalization) {
      const personalizationContent = accordionPersonalization.querySelector('.w-full.font-futuraPT');
      if (personalizationContent) {
        tabPersonalization.innerHTML = personalizationContent.innerHTML;
        accordionPersonalization.remove();
      }
    }
    const tabs = tabsContainer.querySelectorAll('.tab');
    const panesContainer = tabsContainer.nextElementSibling;
    const panes = panesContainer?.querySelectorAll('.tab-pane');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('active'));
        if (panes) {
          panes.forEach(p => p.classList.remove('active'));
        }
        tab.classList.add('active');
        if (tab.getAttribute('data-tab') == 'tab_personalization') {
          option3EventDispatcher();
        }
        const targetPane = document.getElementById(tab.dataset.tab);
        if (targetPane) {
          targetPane.classList.add('active');
        }
      });
    });

    if (productVariantsGrid.children.length == 1) {
      const firstItemHeader = productVariantsGrid.querySelector('.accordeon-header');
      firstItemHeader.click();
    }

    const personalizationContentButtons = document.querySelectorAll('[data-only-option2] button');
    if (personalizationContentButtons) {
      personalizationContentButtons.forEach(button => {
        button.addEventListener('click', () => {
          option3EventDispatcher();
        });
      });
    }
  }

  const accordeonHeaders = document.querySelectorAll('.accordeon-header');
  accordeonHeaders.forEach(header => {
    header.addEventListener('collapse:open', (e) => {
      if (e.detail.target.dataset.accordionId == "personalization") {
        option3EventDispatcher();
      }
    });
  });

  const personalizationType = document.querySelectorAll('[data-personalization-type]');
  if (personalizationType) {
    personalizationType.forEach((element) => {
      element.addEventListener('click', () => {
        personalizationType.forEach(p => p.classList.remove('active'));
        const personalizationTabSelected = document.querySelectorAll('[data-personalization-selected]');
        element.classList.add('active');
        const variant = element.dataset.variant;
        if (personalizationTabSelected) {
          personalizationTabSelected.forEach(item => {
            item.classList.remove('hidden');
            item.querySelector('span').textContent = variant;
          });
        }
        updateInputZepto();
      });
    });
  }

  const stickyCart = document.querySelector('[data-sticky-cart-trigger]');
  const addToCart = document.getElementById('AddToCart');
  const productPrice = document.getElementById('product-price');
  const stickyPrice = stickyCart?.querySelector('[data-sticky-cart-price]');
  const stickyImage = stickyCart?.querySelector('[data-sticky-cart-image] img');
  const stickyTitle = stickyCart?.querySelector('[data-sticky-cart-title]');
  const productForm = addToCart ? addToCart.closest('form') : null;

  const whatsappBtn = document.querySelector('.whatsapp-btn');
  const backtoTopBtn = document.querySelector('.back-to-top');

  if (stickyCart) {
    const stickyButton = stickyCart.querySelector('button');
    let pageLoaded = false;

    window.addEventListener('load', () => {
      pageLoaded = true;
      stickyCart.classList.add("load");
    });

    if (!stickyCart || !addToCart) return;

    let isAddToCartVisible = true;
    let hasScrolledPastAddToCart = false;

    const updateHasScrolledPastAddToCart = () => {
      if (!addToCart) return;

      const rect = addToCart.getBoundingClientRect();
      const addToCartTop = window.scrollY + rect.top;
      const addToCartBottom = addToCartTop + rect.height;

      hasScrolledPastAddToCart = window.scrollY > addToCartBottom;
    };

    const syncStickyPrice = () => {
      if (!productPrice || !stickyPrice) return;

      const nextPrice = productPrice.textContent?.trim();
      if (nextPrice) {
        stickyPrice.textContent = nextPrice;
      }
    };

    const syncStickyTitle = (variant) => {
      if (!stickyTitle || !variant) return;

      const productTitle = stickyTitle.dataset.productTitle?.replace(/ {2,}/g, ' ').trim();
      const variantName = variant.option1?.toUpperCase();
      if (!productTitle || !variantName) return;

      const titleWithPadding = ` ${productTitle.toUpperCase()} `;
      const namesToRemove = [` ${variantName}E`, ` ${variantName}`, ` ${variantName.slice(0, -1)}`];
      const titleWithoutToile = namesToRemove.reduce((title, name) => title.includes(name) ? title.replace(name, '') : title, titleWithPadding).trim();
      const finition = variant.option1.trim().split(/\s+/).slice(0, -1).join(' ');

      stickyTitle.textContent = [titleWithoutToile, finition, variant.option2].filter(Boolean).join(' ');
    };

    const syncStickyTitleFromCurrentVariant = () => {
      const variantId = productForm?.querySelector('input[name="id"]')?.value;
      const productJson = document.querySelector('variant-selector .product-json');
      if (!variantId || !productJson?.textContent) return;

      try {
        const product = JSON.parse(productJson.textContent);
        const variant = product.variants?.find(({ id }) => String(id) === variantId);
        syncStickyTitle(variant);
      } catch (error) {
        // Keep the initial Liquid-rendered title if variant data is unavailable.
      }
    };

    const syncStickyImage = () => {
      if (!stickyImage) return;

      const currentGalleryImage = document.querySelector('#product-hero-carousel .embla__slide.is-selected img, #product-hero-carousel .embla__slide img');

      if (currentGalleryImage) {
        const imageSrc = currentGalleryImage.currentSrc || currentGalleryImage.src;
        const imageAlt = currentGalleryImage.alt;

        if (stickyImage.src !== imageSrc) {
          stickyImage.src = imageSrc;
          stickyImage.srcset = '';
        }

        if (imageAlt) {
          stickyImage.alt = imageAlt;
        }
      }
    };

    const syncStickyButtonState = () => {
      if (!addToCart || !stickyButton) return;

      stickyButton.disabled = addToCart.disabled;
      stickyButton.classList.toggle('sold-out', addToCart.classList.contains('sold-out'));
    };

    const isCartDrawerOpen = () => {
      const cartDrawer = document.getElementById('Cart-Drawer');
      return document.body.classList.contains('open-cart') || !!cartDrawer?.classList.contains('active');
    };

    const updateFloatingButtons = () => {
      if (!whatsappBtn || !backtoTopBtn) return;

      const isStickyActive = stickyCart.classList.contains('active');
      whatsappBtn?.classList.toggle('is-sticky', isStickyActive);
      backtoTopBtn?.classList.toggle('is-sticky', isStickyActive);
    };

    const updateStickyVisibility = () => {
      if (pageLoaded) {
        const shouldShow = hasScrolledPastAddToCart && !isAddToCartVisible && !isCartDrawerOpen();

        if (shouldShow) {
          stickyCart.classList.add("active");
          stickyCart.classList.remove('is-hidden-by-drawer');
        } else {
          stickyCart.classList.remove("active");
          if (isCartDrawerOpen()) {
            stickyCart.classList.add('is-hidden-by-drawer');
          } else {
            stickyCart.classList.remove('is-hidden-by-drawer');
          }
        }

        updateFloatingButtons();
      }
    };

    const addToCartObserver = new IntersectionObserver(
      ([entry]) => {
        isAddToCartVisible = entry.isIntersecting;
        updateHasScrolledPastAddToCart();
        updateStickyVisibility();
      },
      {
        rootMargin: "-100px 0px 0px 0px",
        threshold: 0
      }
    );

    addToCartObserver.observe(addToCart);

    window.addEventListener('scroll', () => {
      updateHasScrolledPastAddToCart();
      updateStickyVisibility();
    }, { passive: true });

    window.addEventListener('resize', () => {
      updateHasScrolledPastAddToCart();
      updateStickyVisibility();
    });

    stickyButton.addEventListener("click", (e) => {
      e.preventDefault();
      addToCart.click();
    });

    const productPriceObserver = productPrice ? new MutationObserver(syncStickyPrice) : null;
    productPriceObserver?.observe(productPrice, {
      childList: true,
      subtree: true,
      characterData: true
    });

    const imageObserverTarget = document.getElementById('product-hero-carousel');
    const imageObserver = imageObserverTarget ? new MutationObserver(() => {
      syncStickyImage();
      syncStickyTitleFromCurrentVariant();
    }) : null;
    imageObserver?.observe(imageObserverTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'src', 'srcset']
    });

    const addToCartButtonObserver = new MutationObserver(() => {
      syncStickyButtonState();
      updateStickyVisibility();
    });

    addToCartButtonObserver.observe(addToCart, {
      attributes: true,
      attributeFilter: ['class', 'disabled']
    });

    if (productForm) {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      if (variantIdInput) {
        const variantObserver = new MutationObserver(() => {
          syncStickyPrice();
          syncStickyImage();
          syncStickyTitleFromCurrentVariant();
          syncStickyButtonState();
        });

        variantObserver.observe(variantIdInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }

      productForm.addEventListener('change', (e) => {
        syncStickyImage();
        syncStickyTitleFromCurrentVariant();
      });
    }

    document.addEventListener('cart-drawer:open', () => {
      updateStickyVisibility();
    });

    document.addEventListener('panel:close', () => {
      window.requestAnimationFrame(updateStickyVisibility);
    });

    document.addEventListener('product:variant-change', ({ detail }) => {
      syncStickyTitle(detail?.detail?.variant || detail?.variant);
    });

    updateHasScrolledPastAddToCart();
    syncStickyPrice();
    syncStickyImage();
    syncStickyButtonState();
    updateStickyVisibility();
  }
});

function setupSliderInteraction() {
  const buttonLeft = document.querySelector("#tab_option2 [data-scroll-left]");
  const buttonRight = document.querySelector("#tab_option2 [data-scroll-right]");
  const container = document.querySelector("#tab_option2 .group-slider-scrollable");
  if (!container || !buttonLeft || !buttonRight) return;
  updateArrowState(container, buttonLeft, buttonRight);
  container.addEventListener("scroll", function () {
    updateArrowState(container, buttonLeft, buttonRight);
  });
  buttonLeft.addEventListener("click", function (o) {
    o.preventDefault();
    o.stopPropagation();
    this.nextElementSibling.scrollBy({
      left: -200,
      behavior: "smooth"
    });
  });
  buttonRight.addEventListener("click", function (o) {
    o.preventDefault();
    o.stopPropagation();
    this.previousElementSibling.scrollBy({
      left: 200,
      behavior: "smooth"
    });
  });
  document.querySelectorAll("#tab_option2 .group-slider-scrollable").forEach(r => {
    const o = r;
    if (!o) return;
    let i = !1, s = 0, a = 0, l = null, c = !1;
    o.addEventListener("mousedown", d => {
      i = !0, d.target instanceof HTMLElement && (l = d.target.closest("button")), c = !1, o.classList.remove("cursor-grab"), o.classList.add("cursor-grabbing"), s = d.pageX - o.offsetLeft, a = o.scrollLeft, d.preventDefault()
    }), o.addEventListener("mouseleave", () => {
      i = !1, o.classList.remove("cursor-grabbing"), o.classList.add("cursor-grab")
    }), o.addEventListener("mouseup", () => {
      i = !1, o.classList.remove("cursor-grabbing"), o.classList.add("cursor-grab"), !c && l && l.click()
    }), o.addEventListener("mousemove", d => {
      if (!i) return;
      d.preventDefault();
      const h = (d.pageX - o.offsetLeft - s) * 1.5;
      o.scrollLeft = a - h, Math.abs(h) > 5 && (c = !0)
    }), document.addEventListener("mouseup", () => {
      i && (i = !1, o.classList.remove("cursor-grabbing"), o.classList.add("cursor-grab"))
    }), o.addEventListener("touchstart", d => {
      i = !0, d.target instanceof HTMLElement && (l = d.target.closest("button")), c = !1, s = d.touches[0].pageX - o.offsetLeft, a = o.scrollLeft
    }), o.addEventListener("touchend", () => {
      i = !1, !c && l && l.click()
    }), o.addEventListener("touchmove", d => {
      if (!i) return;
      const h = d.touches[0].pageX - o.offsetLeft - s;
      o.scrollLeft = a - h, Math.abs(h) > 5 && (c = !0)
    })
  })
}

function updateArrowState(container, buttonLeft, buttonRight) {
  container.scrollLeft <= 0 ?
    buttonLeft.classList.add("opacity-30", "pointer-events-none") :
    buttonLeft.classList.remove("opacity-30", "pointer-events-none");
  Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth ?
    buttonRight.classList.add("opacity-30", "pointer-events-none") :
    buttonRight.classList.remove("opacity-30", "pointer-events-none");
}

document.addEventListener('readystatechange', () => {
  const isEcussonPersonalization = document.querySelector(".pplr-lcusson-option");
  const persoEcusson = document.querySelector("#perso-ecusson");
  if (persoEcusson && isEcussonPersonalization) {
    persoEcusson.style = 'display:flex;';
  }

  const tabOption1 = document.getElementById('tab_option1');

  if (!tabOption1) {
    setTimeout(setupSliderInteraction, 150);
  }
});

function updateInputZepto() {
  const productPersonalizerForms = document.querySelectorAll('.product-personalizer');
  if (productPersonalizerForms) {
    productPersonalizerForms.forEach((form) => {
      const inputs = form.querySelectorAll('[data-pplr_price]');
      inputs.forEach((personalizerInput) => {
        personalizerInput.addEventListener('click', (e) => {
          const addToCartPersonnaliser = document.querySelector('#product-personalizer-form');
          if (addToCartPersonnaliser) {
            let inputsNotFound = [];
            document.querySelector('.product-personalizer').querySelectorAll('input').forEach((inputCurrent) => {
              let inputFound = false;
              addToCartPersonnaliser.querySelectorAll('input').forEach((input) => {
                const matchingInput = inputCurrent.name === input.name;
                if (matchingInput) {
                  input.value = inputCurrent.value;
                  inputFound = true;
                }
              });
              if (inputFound === false) {
                inputsNotFound.push(inputCurrent);
              }
            });
            if (inputsNotFound.length > 0) {
              inputsNotFound.forEach((inputCurrent) => {
                // creating input if it doesn't exist in the add to cart form
                const newInput = document.createElement('input');
                newInput.type = 'hidden';
                newInput.name = inputCurrent.name;
                newInput.value = inputCurrent.value;
                addToCartPersonnaliser.appendChild(newInput);
              });
            }
          }
        });
      });
    });
  }
}